import {
  forwardRef,
  useEffect,
  useCallback,
} from 'react';
import { useLocation } from 'react-router-dom';
import {
  node,
  oneOf,
  string,
} from 'prop-types';
import {
  Container,
  makeStyles,
} from '@material-ui/core';

import track from 'utils/analytics';
import { getSettings } from 'utils/settings';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  cronInput: {
    marginTop: theme.spacing(2),
  },
}));

const Page = forwardRef(({ children, maxWidth, title, ...rest }, ref) => {
  const classes = useStyles();
  const location = useLocation();
  const {
    favicon,
    title: siteTitle,
  } = getSettings('site', {});

  const sendPageViewEvent = useCallback(() => {
    track.pageview({
      page_path: location.pathname,
    });
  }, [location]);

  useEffect(() => {
    sendPageViewEvent();
  }, [sendPageViewEvent]);

  useEffect(() => {
    const { REACT_APP_STAGE: APP_STAGE } = process.env;
    const stage = APP_STAGE !== 'production'
      ? ` (${APP_STAGE})`
      : '';

    document.title = `${title ? `${title} - ` : ''}${siteTitle}${stage}`;
    if (favicon) {
      document.querySelector('link[rel="icon"]').href = favicon;
    }
  }, [title]);

  return (
    <div className={classes.root} ref={ref} {...rest}>
      <Container
        children={children}
        maxWidth={maxWidth}
      />
    </div>
  );
});

Page.defaultProps = {
  maxWidth: false,
};

Page.displayName = 'Page';

Page.propTypes = {
  children: node,
  favicon: string,
  maxWidth: oneOf([
    'lg',
    'md',
    'sm',
    'xl',
    'xs',
    false,
  ]),
  siteTitle: string,
  title: string,
};

export default Page;
